/**
 * Typed wrapper for tutor message feedback.
 *
 * Contract: POST /portal/tutor/messages/:messageId/feedback
 *   body {rating:'up'|'down', reasons?, comment?<=1000, sessionId?} -> {id, rating}
 *
 * Delegates to `@hauraki/api-client` (`tutor.sendTutorFeedback`) via the shared
 * client, so auth, base URL and the 401 handling match the other migrated calls.
 */
import { apiClient } from './apiClient';
import type {
  TutorFeedbackPayload,
  TutorFeedbackReason,
  TutorFeedbackResult,
} from '@hauraki/api-client';

export type { TutorFeedbackPayload, TutorFeedbackReason, TutorFeedbackResult };

export async function sendTutorFeedback(
  messageId: string,
  payload: TutorFeedbackPayload,
): Promise<TutorFeedbackResult> {
  const body: TutorFeedbackPayload = {
    ...payload,
    ...(payload.comment !== undefined ? { comment: payload.comment.slice(0, 1000) } : {}),
  };
  return apiClient.tutor.sendTutorFeedback(messageId, body);
}
